module.exports = function(ctx) {
var __t, __p = '';
__p += '<div>\n	' +
((__t = ( ctx.wizardHeader )) == null ? '' : __t) +
'\n	<div class="dynamic-forms-wizard-page-container">\n		<div class="position-relative">\n			<div class="wizard-page" ref="' +
((__t = ( ctx.wizardKey )) == null ? '' : __t) +
'">\n				' +
((__t = ( ctx.components )) == null ? '' : __t) +
'\n			</div>\n			' +
((__t = ( ctx.wizardNav )) == null ? '' : __t) +
'\n		</div>\n	</div>\n</div>\n';
return __p
}